import builder from '../builder';
import SingleNeutralActionsEdit1 from '../../streamline-icons/light/single-neutral-actions-edit-1.svg';

export default builder(
  'IconSingleNeutralActionsEdit1Light',
  SingleNeutralActionsEdit1,
);
